import { Container, Label, SelectIndicator, ValueContainer, Input } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useUniqueId from '../../hooks/useUniqueId.js';

var SwitchButton = function SwitchButton(_ref) {
  var checked = _ref.checked,
    label = _ref.label,
    leftUnCheckedElement = _ref.leftUnCheckedElement,
    onChange = _ref.onChange,
    rightCheckedElement = _ref.rightCheckedElement;
  var inputId = useUniqueId('switch-button');
  return /*#__PURE__*/jsxs(Container, {
    children: [/*#__PURE__*/jsx(Label, {
      htmlFor: inputId,
      children: label
    }), /*#__PURE__*/jsx(SelectIndicator, {
      $checked: checked
    }), /*#__PURE__*/jsx(ValueContainer, {
      $checked: !checked,
      children: leftUnCheckedElement
    }), /*#__PURE__*/jsx(ValueContainer, {
      $checked: checked,
      children: rightCheckedElement
    }), /*#__PURE__*/jsx(Input, {
      "aria-checked": checked,
      checked: checked,
      id: inputId,
      onChange: onChange,
      role: "switch",
      type: "checkbox"
    })]
  });
};
SwitchButton.defaultProps = {
  checked: false,
  leftUnCheckedElement: /*#__PURE__*/jsx("p", {
    children: "false"
  }),
  rightCheckedElement: /*#__PURE__*/jsx("p", {
    children: "true"
  })
};
var SwitchButton$1 = SwitchButton;

export { SwitchButton$1 as default };
//# sourceMappingURL=SwitchButton.js.map
